export default (() => {
  const {
    xy_runtime_utils: utils = {}
  } = window;
  const {
    getXyHeaders
  } = utils;
  const headers = typeof getXyHeaders === 'function' ? getXyHeaders() : {};
  return headers;
});
//# sourceMappingURL=getCustomHeaders.js.map
